export default __webpack_public_path__ + "static/media/linkedinlogo.e27ee7bb.webp";